


import ClicksWithFtd from "./ClicksWithFtd";
import ProblematicFtd from "./ProblematicFtd";


const AnomaliesFtd = () => {
  return (
    <>
      <ClicksWithFtd />
      <ProblematicFtd />
    </>
  );
};

export default AnomaliesFtd;
